module.exports = __webpack_public_path__ + "static/media/crohns2.3e52a7bf.jpg";